import React from 'react';
import { NextPage } from 'next';
import { makeStyles } from '@material-ui/core/styles';
import Main from '@/layouts/Main';
import PageTitle from '@/components/common/PageTitle';
import BottomBanner from '@/components/common/BottomBanner';
import FavoriteTabContainer from '@/containers/favorites/FavoriteTabContainer';
import Head from '@/components/common/Head';
import styles from 'styles/jss/original/pages/favorites';
import meta from '@/config/meta';
import basicAuthentication from '@/lib/basicAuthentication';
import { wrapper } from '@/store/configureStore';

// @ts-expect-error
const useStyles = makeStyles(styles);

const FavoritesPage: NextPage = () => {
  const classes = useStyles();
  return (
    <div className={classes.page}>
      <Main>
        <Head
          title={meta.favorite.title}
          description={meta.favorite.description}
          image={meta.favorite.image}
          url={meta.favorite.url}
        />
        <div className={classes.main}>
          <PageTitle title='お気に入り' category='FAVORITE' />
          <FavoriteTabContainer />
          <BottomBanner />
        </div>
      </Main>
    </div>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(async ({ req, res }) => {
  if (!process.browser) {
    basicAuthentication({ req, res });
  }
});

export default FavoritesPage;
